module.exports = __webpack_public_path__ + "static/hero2-251b83d6acf1dc11dca17bc59f2ada65.jpg";